"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateStatus = void 0;
var RateStatus;
(function (RateStatus) {
    RateStatus["ACTIVE"] = "ACTIVE";
    RateStatus["EXPIRED"] = "EXPIRED";
    RateStatus["EXPIRING"] = "EXPIRING";
    RateStatus["MISSING"] = "MISSING";
})(RateStatus = exports.RateStatus || (exports.RateStatus = {}));
